<template>
  <button>Entrar</button>
</template>

<script>
export default {
  name: 'BtnLoginAdm'
}
</script>

<style scoped>
button {
  width: 70%;
  border: 0;
  padding-top: 3.5%;
  padding-bottom: 3.5%;
  border-radius: 5px;
  cursor: pointer;
  background-color: #35adfb;
  color: #FFFFFF
}
</style>
